import { defaultTipoAcuerdo, TipoAcuerdoProps } from "./TipoAcuerdoInterface";

// Definición de defaults

export const defaultSubTipoAcuerdo: SubTipoAcuerdoProps = {
    idSubTipoAcuerdo:      0,
    descripcion:           '',
    listaAcuerdo:          false,
    activo:                false,
    idTipoAcuerdo:         0,
    tipoAcuerdo:           defaultTipoAcuerdo,
}

// Creación de interfaces

export interface SubTipoAcuerdoProps {
    idSubTipoAcuerdo:            number;
    descripcion:           string;
    listaAcuerdo:          boolean;
    activo:                boolean;
    idTipoAcuerdo?:        number;
    tipoAcuerdo?:          TipoAcuerdoProps;    

}